import { useEffect, useState } from "react";

export default function RosterHero() {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setLoaded(true), 80);
    return () => clearTimeout(t);
  }, []);

  return (
    <header className="relative w-full h-[50vh] min-h-[420px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/2aa42b6c8da40a230341a58150a81a3b.jpg"
          alt="PWA Roster"
          className="w-full h-full object-cover object-center transition-transform duration-[6000ms] ease-out"
          style={{ transform: loaded ? "scale(1)" : "scale(1.06)" }}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/55 to-black/30" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-black/40" />
        <div className="absolute bottom-0 right-0 w-80 h-80 border-r border-b border-orange-500/12 pointer-events-none" />
      </div>

      <div className="absolute bottom-1/2 right-1/4 w-64 h-32 bg-orange-500/10 blur-3xl pointer-events-none" />

      <div className="relative z-10 h-full flex flex-col justify-end pb-14 md:pb-20 px-6 md:px-16 lg:px-24 w-full">
        <div
          className={`inline-block bg-orange-500 text-white font-condensed font-bold text-xs uppercase tracking-widest px-3 py-1 mb-4 w-fit anim-hidden ${loaded ? "animate-fade-in-left" : ""}`}
        >
          Pacific Wrestling Alliance
        </div>
        <h1
          className={`font-condensed font-black text-white uppercase leading-none tracking-tight text-5xl md:text-7xl anim-hidden ${loaded ? "animate-fade-in-left delay-100" : ""}`}
        >
          The Roster
        </h1>
        <p
          className={`text-white/70 mt-3 text-sm md:text-base max-w-lg anim-hidden ${loaded ? "animate-fade-in-up delay-200" : ""}`}
        >
          Meet the athletes who step inside the ropes. The warriors, the showmen, the legends in the making.
        </p>
      </div>
    </header>
  );
}
